import { UseFormReturn } from "react-hook-form";
import { PatchPolicyFormValues } from "@/components/patching/schema";
import { DeviceMonitoringSection } from "./general/DeviceMonitoringSection";
import { ApplicationPreferencesSection } from "./general/ApplicationPreferencesSection";
import { NotificationSettingsSection } from "./general/NotificationSettingsSection";
import { ThemeAppearanceSection } from "./general/ThemeAppearanceSection";
import { ByokKeysSection } from "./general/ByokKeysSection";
import { SessionSettingsSection } from "./general/SessionSettingsSection";

interface GeneralSettingsProps {
  form: UseFormReturn<PatchPolicyFormValues>;
}

export function GeneralSettings({ form }: GeneralSettingsProps) {
  return (
    <div className="space-y-6">
      <DeviceMonitoringSection />
      <ApplicationPreferencesSection />
      <NotificationSettingsSection form={form} />
      <ThemeAppearanceSection />
      <ByokKeysSection />
      <SessionSettingsSection />
    </div>
  );
}
